import { default as calculationVj5vUiyTc7Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailho7P6KPZ1jMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryr0dzLr6sSHMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93CYMQj7W1toMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listdQxavjxDToMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testing64jT5CIs0eMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyouAUNLXCGjLbMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellcMFmlMPP7MMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostdJEhNIvDZTMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankObbITAoXfzMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniZgrF3Hm4PoMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pagegEUrf1QKdIMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testqRbzg3ldiaMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagenNsmrvr0N2Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articledSBNpfE6uwMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patterns6qVeuPUYNtMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tag3i0Jxlb7UGMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorJWjPtViUHEMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryoCfX1urUCXMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionJCdQyHXr9dMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesnAqXE31ESzMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryukUN3oHLV4Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleMY9Sk5Ysz3Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionHfkP8iyyBIMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactu21179VGYpMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45termination7nXXcp4h1KMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculation6IxRJoczxgMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45you5rtQfZ5ujHMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailDxXIlNUMn4Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryp512ouv93OMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listIC9RF1QcSNMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculation3IWjPVOS3yMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youKjqj8xNBNXMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquirysptOMWMf0aMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listHhbVUo7888Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailDa2oqtZM7xMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offercqFEAsBCLXMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryjYMMkCM3GiMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youYUsKAImBbhMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculation4iR4xMd302Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listxKGzzBps7wMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45yougAIPgYe9yvMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlinekvKWSSYVazMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailub9vwmhzUXMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phone5J9MdEh8WvMeta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerO6ZsL7z1L1Meta } from "/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostdJEhNIvDZTMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankObbITAoXfzMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniZgrF3Hm4PoMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pagegEUrf1QKdIMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testqRbzg3ldiaMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagenNsmrvr0N2Meta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articledSBNpfE6uwMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patterns6qVeuPUYNtMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tag3i0Jxlb7UGMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorJWjPtViUHEMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryoCfX1urUCXMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionJCdQyHXr9dMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesnAqXE31ESzMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pagegEUrf1QKdIMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryukUN3oHLV4Meta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleMY9Sk5Ysz3Meta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionHfkP8iyyBIMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionHfkP8iyyBIMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactu21179VGYpMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45termination7nXXcp4h1KMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculation6IxRJoczxgMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45you5rtQfZ5ujHMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailDxXIlNUMn4Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryp512ouv93OMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listIC9RF1QcSNMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculation3IWjPVOS3yMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youKjqj8xNBNXMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquirysptOMWMf0aMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listHhbVUo7888Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailDa2oqtZM7xMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offercqFEAsBCLXMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryjYMMkCM3GiMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youYUsKAImBbhMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculation4iR4xMd302Meta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listxKGzzBps7wMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45yougAIPgYe9yvMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlinekvKWSSYVazMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailub9vwmhzUXMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phone5J9MdEh8WvMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerO6ZsL7z1L1Meta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src773912363/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]